import { TFunction } from 'i18next';

import { ApiError } from '../api/ApiError';
import { INotification } from '../ui/Notifications/types';

export const globalOnError = (
  error: ApiError,
  t: TFunction,
  addNotification: (notification: INotification) => void
) => {
  if (ApiError.isCanceledError(error)) {
    return;
  }

  const errorMessage = error?.message;
  if (typeof errorMessage === 'string' && errorMessage.trim() !== '') {
    const errorDetails = error?.data?.details;
    const caption = errorDetails !== errorMessage ? errorDetails : undefined;

    addNotification({
      type: 'error',
      title: errorMessage,
      caption,
    });
  } else {
    addNotification({
      type: 'error',
      caption: t('common:messages.error'),
    });
  }
};
